export const liCss = `
:root{
  --lip-text:#111827;
  --lip-muted:#6b7280;
  --lip-border:#e5e7eb;
  --lip-bg:#ffffff;
  --lip-soft:rgba(0,0,0,0.03);
  --lip-link:#2563eb;
}
.dark :root{
  --lip-text:#e5e7eb;
  --lip-muted:#9ca3af;
  --lip-border:#262626;
  --lip-bg:#0a0a0a;
  --lip-soft:rgba(255,255,255,0.06);
  --lip-link:#60a5fa;
}

.lip-container{max-width:672px;margin:0 auto;padding:32px 16px;}
.lip-card{background:var(--lip-bg);border:1px solid var(--lip-border);color:var(--lip-text);border-radius:12px;box-shadow:0 1px 2px rgba(0,0,0,.06);overflow:hidden;}

.lip-header{display:flex;align-items:flex-start;gap:12px;padding:16px 20px 12px 20px;}
.lip-avatar{width:48px;height:48px;border-radius:999px;object-fit:cover;flex:0 0 auto;}
.lip-header-main{min-width:0;flex:1 1 auto;}
.lip-name-row{display:flex;align-items:center;gap:6px;}
.lip-name{font-weight:600;text-decoration:none;color:inherit;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;}
.lip-name:hover{text-decoration:underline;}
.lip-subtitle{font-size:12px;color:var(--lip-muted);line-height:1.25;}
.lip-subtitle-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.lip-subline{display:inline-flex;align-items:center;gap:6px;margin-top:2px;}
.lip-geo{width:16px;height:16px;fill:currentColor;color:var(--lip-muted);}
.lip-more{border:0;background:transparent;border-radius:999px;padding:8px;cursor:pointer;}
.lip-more:hover{background:var(--lip-soft);}
.lip-more-icon{width:20px;height:20px;fill:currentColor;color:var(--lip-muted);}

.lip-body{padding:0 20px 12px 20px;line-height:1.35;white-space:pre-line;word-wrap:break-word;}
.lip-link{color:var(--lip-link);text-decoration:none;}
.lip-link:hover{text-decoration:underline;}

/* Link card */
.lip-link-card{display:block;margin:16px 20px;border:1px solid var(--lip-border);border-radius:12px;overflow:hidden;text-decoration:none;color:inherit;transition:background 120ms ease;}
.lip-link-card:hover{background:var(--lip-soft);}
.lip-link-card-media{width:100%;background:#f3f4f6;aspect-ratio:120/63;} /* LI previewish ratio */
.lip-link-card-img{width:100%;height:100%;object-fit:cover;}
.lip-link-card-body{padding:12px 16px;}
.lip-link-card-domain{text-transform:uppercase;font-size:11px;letter-spacing:.04em;color:var(--lip-muted);}
.lip-link-card-title{margin-top:4px;font-weight:600;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}
.lip-link-card-desc{margin-top:6px;font-size:14px;color:var(--lip-muted);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}

/* Hashtags */
.lip-hashtags{padding:0 20px 8px 20px;}
.lip-tag{display:inline-block;margin-right:8px;margin-bottom:6px;font-size:14px;color:#1d4ed8;word-break:break-all;}
.dark .lip-tag{color:#60a5fa;}

/* Post media (standalone image) */
.lip-media-wrap{background:var(--lip-soft);}
.lip-media{display:block;width:100%;max-height:520px;object-fit:cover;}
@media(min-width:640px){.lip-media{object-fit:contain;}}

/* Counters */
.lip-counters{padding:8px 20px;display:flex;align-items:center;justify-content:space-between;font-size:14px;color:var(--lip-muted);}
.lip-counters-left{display:flex;align-items:center;gap:8px;}
.lip-reaction-bubbles{display:flex;align-items:center;}
.lip-bubble{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:999px;margin-left:-4px;box-shadow:0 0 0 2px var(--lip-bg);}
.dark .lip-bubble{box-shadow:0 0 0 2px var(--lip-bg);}
.lip-bubble-icon{width:14px;height:14px;color:#fff;}
.lip-like{background:#2563eb;}
.lip-celebrate{background:#059669;}
.lip-insightful{background:#d97706;}
.lip-counters-right{display:flex;align-items:center;gap:12px;}
.lip-divider{border:0;border-top:1px solid var(--lip-border);margin:0;}

/* Actions */
.lip-actions{padding:6px 8px;display:grid;grid-template-columns:repeat(4,1fr);gap:0;}
.lip-action{width:100%;display:flex;align-items:center;justify-content:center;gap:8px;font-weight:500;font-size:13px;padding:8px 0;background:transparent;border:0;border-radius:8px;cursor:pointer;}
.lip-action:hover{background:var(--lip-soft);}
.lip-action:active{background:rgba(0,0,0,.08);}
.dark .lip-action:active{background:rgba(255,255,255,.08);}
.lip-action-icon{width:24px;height:24px;fill:currentColor;}
`;
